import React, { useContext } from 'react';
import { useRecoilValue } from 'recoil';
import { MeasurementBanner as MeasurementBannerContent } from 'pages/common/components/MeasurementBanner';
import { measurementAtom } from 'pages/common/store/measurement';
import { LEMANAPRO_ROOT_URL } from 'pages/common/consts/urls';
import { DataContext } from 'entries/common/widgets/saved-project-configuration/context';

export const MeasurementBanner = () => {
  const { data } = useContext(DataContext);
  const hasPresaleProps = Boolean(data?.presaleProps);
  const measurement = useRecoilValue(measurementAtom);
  const { price, serviceURL, title, currency } = measurement;

  if (!price || !serviceURL || !title || !currency) {
    return null;
  }

  const measurementServiceURL = hasPresaleProps
    ? new URL(serviceURL, `${LEMANAPRO_ROOT_URL}/`).toString()
    : serviceURL;

  return (
    <MeasurementBannerContent priceMin={price} serviceURL={measurementServiceURL} serviceName={title} />
  );
};
